module.exports = __webpack_public_path__ + "static/img/login-bg.42ca086.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/login-bg.png
// module id = /HQc
// module chunks = 1